export default [
  {
    path: "/marketing-dashboard",
    name: "marketing-main",
    component: () => import("../../modules/Marketing/pages/MainPage.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["marketing"],
    },
  },
  {
    path: "/marketing-bot",
    name: "marketing-group-bot",
    component: () =>
      import("../../modules/Marketing/widgets/BotWidget/BotWidget.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["marketing"],
    },
  },
  {
    path: "/channel-bot",
    name: "marketing-channel-bot",
    component: () =>
      import("../../modules/Marketing/widgets/ChannelBot/BotChannel.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["marketing"],
    },
  },
  {
    path: "/marketing-coins",
    name: "marketing-coins",
    component: () =>
      import("../../modules/Marketing/widgets/CoinWidget/CoinWidget.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["marketing"],
    },
  },
  {
    path: "/marketing-news",
    name: "marketing-news",
    component: () =>
      import("../../modules/Marketing/widgets/NewsWidget/NewsWidget.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["marketing"],
    },
  },
  {
    path: "/marketing-shop",
    name: "marketing-shop",
    component: () =>
      import("../../modules/Marketing/widgets/ShopWidget/ShopWidget.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["marketing"],
    },
  },
  {
    path: "/marketing-survey",
    name: "marketing-survey",
    component: () =>
      import("../../modules/Marketing/widgets/Survey/Survey.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["marketing"],
    },
  },
  {
    path: "/marketing-badges",
    name: "marketing-badges",
    component: () =>
      import("../../modules/Marketing/widgets/BadgesWidget/BadgesWidget.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["marketing"],
    },
  },
];
